module.exports = __webpack_public_path__ + "static/media/hand_click.a4365242.svg";